import { LoadStatusWithResponseDetail } from "../../../../../../../common/utils/async-status";
import { getEventActionName } from "../../../core/make-action";
import ViewerEvent from "../../../core/ViewerEvent";

export default function (
  state = {
    status: LoadStatusWithResponseDetail.PENDING,
    lastValidPage: {},
    errorInfo: null,
  },
  action
) {
  switch (action.type) {
    case getEventActionName(ViewerEvent.NAVIGATION_REQUESTED):
      return {
        ...state,
        status: LoadStatusWithResponseDetail.PENDING,
        errorInfo: null,
      };
    case getEventActionName(ViewerEvent.PAGE_READY):
      return {
        ...state,
        status: LoadStatusWithResponseDetail.OK,
        lastValidPage: action.eventData,
      };
    case getEventActionName(ViewerEvent.PAGE_ERROR):
      return {
        // keep around the last valid page info so the UI doesn't blip
        // if an error occurs. Most code is going to assume that after that
        // first load there will always be valid location data around.
        ...state,
        status: LoadStatusWithResponseDetail.ERROR,
        errorInfo: action.eventData,
      };
    default:
      return state;
  }
}
